<template>
  <div class="row">
    <div v-if="loading" class="col" >
      <span class="loading text-muted">Loading...</span>
    </div>
    <div v-if="!loading" class="col" >
        <div class="row">
          <supplier-r-f-q-table class="pr-1" name="standard" title="Standard" v-bind:data="data.standard" />
          <supplier-r-f-q-table class="pl-2 pr-2" name="overnight" title="Overnight" v-bind:data="data.overnight" />
          <supplier-r-f-q-table class="pl-1" name="expedited" title="Expedited" icon="expeditedOne" v-bind:data="data.expedited" />
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import apiService from '../../services/api.service'

import BaseIcon from '../../components/icons/BaseIcon.vue'
import SupplierRFQTable from'./SupplierRFQTable.vue'

import { checkResponseErrors } from '../../utils/http'
import moment from 'moment'

export default {
  name: 'SupplierRFQWidget',
  data: () => ({
    loading: true,
    data: null,
  }),
  components: {
    BaseIcon,
    SupplierRFQTable
  },
  async mounted () {
    this.loading = true;

    try {
      const resp = await apiService.get('/dashboard/supplierRFQ');
      if(await checkResponseErrors(resp)) return;

      this.data = initWidgetData(resp.data);
      this.loading = false;
    } catch (error) {
      Vue.toasted.error(error, { duration: 3500 });
      return;
    }
  }, // end mounted
}

const initWidgetData = (data) => {
  var widgData = data.data;

  // set the widths for the div comparing their relative size to the other categories
  setWidths(widgData.standard);
  setWidths(widgData.overnight);
  setWidths(widgData.expedited);
  
  return widgData
}

const setWidths = (data) => {
  var maxValue = getMaxValue(data)

  Object.entries(data).forEach((entry) => {
    const key = entry[0]
    const value = entry[1]
    const width = maxValue > 0? (parseInt((value / maxValue) * 100) + "%") : 0
    
    data[key + "Width"] = { "width": width }
  })
}

const getMaxValue = (data) => {
  var max = 0
  Object.values(data).forEach((value) => {
    if(value > max){
      max = value
    }
  })

  return max
}

</script>



// WEBPACK FOOTER //
// SupplierRFQWidget.vue?b3b793ea